import { AssetManagerTemplate, ErrorTemplate } from "../../../templates";

const Error403 = (): JSX.Element => {
  return (
    <AssetManagerTemplate>
      <ErrorTemplate errorText="The page or resource you are trying to view has restricted access." errorCode="403" />
    </AssetManagerTemplate>
  );
};

export default Error403;
